<template>
    <div class="p-5 mt-5">
        <a-form :form="form" style="width: 600px;margin: auto">

            <a-form-item label="供应商类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group  @change="onChange" v-decorator="['supplierType',{initialValue:'1',rules: [{message:'请选择供应商类型',required: true}]}]">
<!--                        <a-radio value="2">-->
<!--                            法人供应商-->
<!--                        </a-radio>-->
                        <a-radio value="1">
                            个体户供应商
                        </a-radio>
                    </a-radio-group>
            </a-form-item>

            <a-form-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-group style="display: inline-block; vertical-align: middle" :compact="true">
                    <a-input v-decorator="['enterpriseName',{initialValue: en.enterpriseName, rules: [{ required: true, message: '单位名称不能为空'}]}]"/>
                </a-input-group>
            </a-form-item>
            <a-form-item label="统一社会信用代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['enterpriseCode',{initialValue: en.enterpriseCode, rules: [{message: '统一社会信用代码不能为空', required: true},{validator: validateSupplierCode}]}]"/>
            </a-form-item>
            <a-form-item class="text-center mb-0">
                <a-button  style="width: 200px" type="primary" @click="nextStep">下一步</a-button>
            </a-form-item>
        </a-form>

        <div class="step-form-style-desc">
        </div>
    </div>
</template>

<script>
    import qs from "qs";

    export default {
        created() {
            this.initData()
            this.getAccountInfo()
        },
        name: 'LegalCertificatStep1',
        data () {
            return {
                labelCol: { lg: { span: 5 }, sm: { span: 5 } },
                wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
                form: this.$form.createForm(this),
                en:'',
                supplierCode:'',
                unitName:'个体户名称',
                unitCode: '注册号'
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/init_certifications.json").then(function (res) {
                    console.log(res)
                    that.en = res.result
                    console.log(that.en.status)
                    if (  that.en.status === '1') {
                        that.$success({
                            title: '提示',
                            content:'单位认证审核中',
                            okText: '确定',
                            onOk:function () {
                                that.$router.push({path:'/account/AccountManage'})
                            }
                        })
                    }else if (that.en.status === '2'){
                        that.$success({
                            title: '提示',
                            content:'您已成功认证，不可重复认证',
                            okText: '确定',
                            onOk:function () {
                                that.$router.push({path:'/account/AccountManage'})
                            }
                        })
                    }else if (that.en.status === '3') {
                        that.$success({
                            title: '单位认证提示',
                            content:'审核不通过；'+ (that.en.opinion ? ('意见:' + that.en.opinion) :'') ,
                            okText: '确定'
                        })
                    }
                });
            },
            getAccountInfo() {
                let that = this
                this.$http.get('/api/v1/supplier/getSupplierInfo.json').then(function (res) {
                    if (res.result){
                        if ((res.result.supplierType === '1' && res.result.natureType === '2' && res.result.supplierId ) || (res.result.supplierType === '2' &&  res.result.supplierId)) {
                            that.$success({
                                title: '提示',
                                content:'你已绑定供应商,不可做认证操作',
                                okText: '确定',
                                onOk:function () {
                                    that.$router.push({path:'/index'})
                                }
                            })
                        }
                    }
                });
            },
            validateSupplierCode(rule, value, callback) {
                var supplierType = this.form.getFieldValue("supplierType");
                if (supplierType === '1') {
                    if ((value && value.length < 13) || (value && value.length > 18)) {
                        callback("注册号格式错误")
                    }
                }else {
                    var  reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g          //统一信用代码
                    if (value && !reg.test(value)) {
                        callback("社会统一信用代码格式不正确")
                    }
                }
                callback();
            },
            nextStep () {
                debugger
                let params = {...this.form.getFieldsValue()}
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    debugger
                    this.$emit('clickSupplier',params.supplierType);
                    var params2 = {};
                    params2.supplierCode =  params.enterpriseCode
                    let that = this
                    this.$http.post('/api/v1/supplier/enterprise/validate.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                        if (res.code === 201) {//信用代码被注册了
                            that.codeInfo(params2.supplierCode)
                        }else if (res.code === 202) {
                            that.sysInfo("社会统一信用代码已被占用,正在审核中，不可再次提交，请重新填写或耐心等待。");
                        }else if (res.code === 203) {
                            that.sysInfo("注册号已被认证，不可再次认证!")
                        } else if (res.code === 200) {
                            that.$emit("commitValue", params.enterpriseCode, params.enterpriseName);
                            that.$emit('nextStep');
                        }
                    });

                });
            },
            codeInfo(value) {
                let that = this
                this.$confirm({
                    title: '提示',
                    content: value+'社会统一信用代码已认证,请重新填写,或者关联该企业',
                    okText: '关联该企业',
                    okType: 'primary',
                    cancelText: '重新填写',
                    onOk() {
                        console.log('关联该企业...'+value);
                        // that.$router.push({path:'/enterprise/ConnectSupplier?supplierCode='+value})
                        that.$router.push({name:'ConnectSupplier', params: {supplierCode:value}} )

                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                })
            },
            sysInfo(value) {
                this.$success({
                    title: '提示',
                    content:value
                })
            },
            onChange(e) {
                if (e.target.value === '2') {
                    this.unitCode = '社会统一信用代码'
                }else if (e.target.value === '1') {
                    this.unitCode = '注册号'
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0,0,0,.45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0,0,0,.45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0,0,0,.45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }
</style>
